import Service from "../AuthService";

const SubDistrict = {
    getSubDistricts(code) {
        return Service.get(`sub-districts/${code}`);
    }
};

export default SubDistrict;
